import { connect } from 'react-redux';

import { APP_UPDATED } from 'Component/NewVersionPopup/NewVersionPopup.config';
import {
    mapDispatchToProps as sourceMapDispatchToProps,
    mapStateToProps as sourceMapStateToProps,
    NewVersionPopupContainer as SourceNewVersionPopupContainer
} from 'SourceComponent/NewVersionPopup/NewVersionPopup.container';
import { showNotification } from 'Store/Notification/Notification.action';
import { isCrawler, isSSR } from 'Util/Browser';
import BrowserDatabase from 'Util/BrowserDatabase/BrowserDatabase';
import { checkAppVersionFromHeader } from 'Util/Cache/VersionCheck';
/** @namespace Bodypwa/Component/NewVersionPopup/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    ...sourceMapStateToProps(state),
    appVersion: state.ConfigReducer.bodymod_app_version
});

/** @namespace Bodypwa/Component/NewVersionPopup/Container/mapDispatchToProps */
export const mapDispatchToProps = (dispatch) => ({
    ...sourceMapDispatchToProps(dispatch),
    showNotification: (type, message) => dispatch(showNotification(type, message))
});

/** @namespace Bodypwa/Component/NewVersionPopup/Container */
export class NewVersionPopupContainer extends SourceNewVersionPopupContainer {
    componentDidMount() {
        if (isCrawler() || isSSR()) {
            // disable popup for crawlers so page content is not blocked and page is scrollable
            return;
        }

        this.notifiUpdate();
        checkAppVersionFromHeader();
    }

    notifiUpdate() {
        const { showNotification } = this.props;
        const appUpdated = BrowserDatabase.getItem(APP_UPDATED);

        if (appUpdated) {
            BrowserDatabase.setItem(false, APP_UPDATED);
            showNotification('info',
                __('We have updated the app and reloaded the page so you can use the latest changes.'));
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NewVersionPopupContainer);
